<template>
  <v-flex shrink>
    <v-row style="fontSize: 14px; padding-top: 5px;">
      <p style="fontWeight: 500; color: #999FB8">{{name}}&nbsp;&nbsp;</p>
      <p style="fontWeight: 500; color: black">{{value}}&nbsp;&nbsp;&nbsp;&nbsp;</p>
    </v-row>
  </v-flex>
</template>

<script>
export default {
  name: "Stat",
  props: {
    name: String,
    value: Number
  },
  computed: {},
  mounted: function() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
